<template>
  <div class="myaccount">
    <CommonHead></CommonHead>
    <b-modal
      id="no-invoice-popup"
      :title="this.invoicenotititle"
      title-tag="h3"
      ok-only
      modal-class="common_pop save_project"
    ></b-modal>
    <div class="accountdetails">
      <sidebar></sidebar>
      <div class="orderspagenew">
        <h1 class="account-mobile">Orders</h1>
        <table class="salesorderList" v-if="!isLoading">
          <thead>
            <tr>
              <td>
                <p>Order No.</p>
              </td>
              <td>
                <p>Date Created</p>
              </td>
              <td>
                <p>Order Type</p>
              </td>
              <td>
                <p>Sidemark</p>
              </td>
              <td>
                <p>Purchase Order No.</p>
              </td>
              <td>
                <p>Status</p>
              </td>
              <td>
                <p>Action</p>
              </td>
              <td></td>
            </tr>
          </thead>
          <tbody v-for="(openorder,openorderind) in openorders" :key="openorderind">
            <tr
              data-toggle="collapse"
              :data-target="'#'+openorder.SALESID"
              :class="['clickable', (openorderind === 0 && form.page === 1 ? '' : 'collapsed')]"
            >
              <td>
                <p>{{openorder.SALESID}}</p>
              </td>
              <td>
                <p>{{openorder.DateCreated}}</p>
              </td>
              <td>
                <p>{{openorder.ORDER_TYPE}}</p>
              </td>
              <td>
                <p>{{openorder.CustomerRef}}</p>
              </td>
              <td>
                <p>{{openorder.PurchOrderFormNum}}</p>
              </td>
              <td>
                <p>{{openorder.SALESSTATUSTEXT}}</p>
              </td>
              <td>
                <p>
                  <a
                    :href="'/shop/singleorder/'+openorder.SALESID"
                    class="viewdetails"
                  >View Order Details</a>
                </p>
              </td>
              <td>
                <img src="/shop/images/add.svg" class="addicon" />
                <img src="/shop/images/minus.svg" class="minusicon" />
              </td>
            </tr>
            <tr>
              <td colspan="8">
                <div :id="openorder.SALESID" :class="['collapse', (openorderind === 0 && form.page === 1 ? 'show' : '')]">
                  <table class="saleslineList">
                    <tr>
                      <td>
                        <p><b>Line No.</b></p>
                      </td>
                      <td>
                        <p><b>Item</b></p>
                      </td>
                      <td>
                        <p><b>Quantity</b></p>
                      </td>
                      <td>
                        <p><b>Line Status</b></p>
                      </td>
                      <td>
                        <p><b>Description</b></p>
                      </td>
                      <td>
                        <p><b>Tag</b></p>
                      </td>
                      <td>
                        <p v-if="openorder.ORDER_TYPE == 'Workroom'"><b>Estimated Ship Date</b></p>
                        <p v-else><b>Ship Date</b></p>
                      </td>
                    </tr>
                    <tr v-for="(oitems,oitemsind) in openorder.ITEMS" :key="oitemsind">
                      <td>
                        <p>{{oitems.LineNum}}</p>
                      </td>
                      <td>
                        <p>{{oitems.Name}}</p>
                      </td>
                      <td>
                        <p>{{oitems.SalesQty}}</p>
                      </td>
                      <td>
                        <p v-if="oitems.invoicepdf == '1'"><a href="javascript:;" v-b-modal.no-invoice-popup class="viewdetails">{{oitems.SALESLINESTATUS}}</a></p>
                        <p v-else-if="oitems.invoicepdf && oitems.invoicepdf != '1'"><a :href="oitems.invoicepdf" class="viewdetails" target="_blank">{{oitems.SALESLINESTATUS}}</a></p>
                        <p v-else>{{oitems.SALESLINESTATUS}}</p>
                      </td>
                      <td>
                        <p>{{oitems.RMC_PatternDescription}}</p>
                      </td>
                      <td>
                        <p>{{oitems.RMC_Tag}}</p>
                      </td>
                      <td>
                        <p>{{oitems.ShippingDateConfirmed}}</p>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <SKLoader :repeat="1" :loading="isLoading" speed="1s">
          <SKOrder />
        </SKLoader>
        <div class="propagination" v-if="rows>10">
          <div class="mt-3 custompage">
            <b-pagination
              v-model="currentPage"
              @input="paginationChange"
              :total-rows="rows"
              :per-page="perPage"
              align="center"
              first-number
              last-number
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ResourceMixin from "../../mixins/resources";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SKOrder from "@/views/skeletons/SKOrder";

export default {
  components: {
    Sidebar,
    CommonHead,
    CommonFoot,
    Loading,
    SKOrder
  },
  mixins: [ResourceMixin],
  mounted() {
    this.loadOrders();
  },
  data() {
    return {
      openorders: [],
      isLoading: false,
      rows: 10,
      perPage: 10,
      currentPage: 1,
      form: {
        page: 1
      },
      breadcrumb: [
        {
          text: "My Account",
          active: true
        }
      ],
      invoicenotititle:'This invoice is not available online, please reach out to accountrelations@rmcoco.com for a copy'      
    };
  },
  methods: {
    paginationChange(page) {
      this.form.page = page;
      this.loadOrders();
    },
    loadOrders() {
      this.isLoading = true;
      this.$store.dispatch("loadOrders", this.form).then(openorders => {
        this.rows = openorders.data.total;
        this.currentPage = this.form.page;
        this.openorders = openorders.data.orders;
        this.isLoading = false;
      });
    }
  }
};
</script>
<style>
.accountdetails .orderspagenew {
  display: block;
  margin-top: 40px;
  padding: 0 20px;
  width: 100%;
  margin-left: 26.3%;
  min-height: 615px;
  max-width: 100%;
  overflow-x: auto;
}
.accountdetails .sk-loader-child{
  width:100%;
}
.accountdetails .orderspagenew .salesorderList {
  width: 100%;
  min-width: 947px;
}
.accountdetails .orderspagenew .salesorderList thead {
  background: #303030;
  color: #fff;
}
.accountdetails .orderspagenew .salesorderList td p {
  margin: 0;
  padding: 10px;
}
.accountdetails .orderspagenew .salesorderList td p a {
  color: #303030;
  font-weight: 500;
  text-decoration: underline;
}
.accountdetails .orderspagenew .salesorderList td img {
  width: 12px;
  height: 12px;
  margin: 0 15px 0 0;
}
.accountdetails .orderspagenew .salesorderList tbody {
  background: #ececec;
}
.accountdetails .orderspagenew .salesorderList tbody .collapsed {
  border-bottom: 2px solid #fff;
}
.accountdetails .orderspagenew .salesorderList tbody .addicon {
  display: none;
}
.accountdetails .orderspagenew .salesorderList tbody .minusicon {
  display: block;
}
.accountdetails .orderspagenew .salesorderList tbody .collapsed .addicon {
  display: block;
}
.accountdetails .orderspagenew .salesorderList tbody .collapsed .minusicon {
  display: none;
}
.accountdetails .orderspagenew .salesorderList .saleslineList {
  width: 100%;
  background: #fff;
}
.accountdetails .orderspagenew .salesorderList .saleslineList td {
  border: 1px solid #d2d2d2;
}
.accountdetails .propagination {
  position: relative;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: 0;
  width: 100%;
}
.accountdetails .propagination .custompage {
  margin-top: 0 !important;
}
.accountdetails .propagination .custompage .pagination {
  align-items: center;
}
.accountdetails .propagination .custompage .page-link {
  border: none;
  color: #777777 !important;
  font-size: 14px;
  font-weight: normal;
  padding: 14px 17px 10px 17px;
}
.accountdetails .propagination .custompage .page-item:first-child .page-link,
.accountdetails .propagination .custompage .page-item:last-child .page-link {
  color: #303030 !important;
  font-size: 28px;
  padding-top: 0;
  padding-bottom: 0;
}
.accountdetails .propagination .custompage .page-item.active .page-link {
  background: transparent;
  font-weight: 600;
  color: #303030 !important;
}
.accountdetails .propagination .custompage .page-item.disabled.bv-d-xs-down-none .page-link {
  font-size: 26px;
}
.accountdetails .propagination .custompage .page-link:hover {
  background: transparent;
  color: #303030;
  font-weight: 600;
}
@media only screen and (max-width: 1360px) {
  .accountdetails .orderspagenew {
    margin-left: 350px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1025px) {
  .accountdetails .orderspagenew {
    margin-left: 300px;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .accountdetails .orderspagenew {
    margin-left: 260px;
  }
}
@media only screen and (max-width: 767px) {
  .accountdetails .orderspagenew {
    margin-left: 0;
  }
}
</style>